// @flow

import React, { Component } from "react"
import App from "./App"
import Navbar from "./Navbar"
import * as firebase from "firebase"
import { Switch, Route } from "react-router-dom"
import Messages from "./Messages"
import Blog from "./Blog"
import "./Shell.css"
import Settings from "./Settings"
import Pro from "./Pro"
import { signIn, signOut } from "./user"
import Wootric from "./vendor/Wootric"
import FrontPage from "./FrontPage"
import SignIn from "./SignIn"

// const DEFAULT_PRICE = 0.004
const YEAR_MONTHLY_PRICE = 0.02 / 12

type Props = {}

type State = {
	uid: ?String,
	email: ?String,
	plan: ?String,
	price: number,
	planExpiresAt: ?Date,
	trialActivatedAt: ?Date,
	showRenewMessage: boolean,
	messages: any,
}

const defaultState: State = {
	uid: null,
	email: null,
	plan: null,
	price: YEAR_MONTHLY_PRICE,
	planExpiresAt: null,
	trialActivatedAt: null,
	showRenewMessage: false,
	messages: {},
}

export default class Shell extends Component<Props, State> {
	unsubscribe: ?() => void

	constructor(props: Props) {
		super(props)
		this.state = defaultState
		this.unsubscribe = null
	}

	componentDidMount() {
		firebase.auth().onAuthStateChanged(user => {
			if (user === null) {
				this.setState(defaultState)
			} else {
				this.setState({
					uid: user.uid,
					email: user.email,
				})
				this.loadData(user.uid)
			}
		})
	}

	async loadData(uid: string) {
		const db = firebase.firestore()
		if (this.unsubscribe != null) {
			this.unsubscribe()
		}
		this.unsubscribe = db
			.collection("users")
			.doc(uid)
			.onSnapshot(doc => {
				if (!doc.exists) {
					return
				}
				const data = doc.data()
				this.setState((prevState, props) => {
					const messages = Object.assign({}, data.messages)
					for (const id of Object.keys(prevState.messages)) {
						const message = prevState.messages[id]
						if (message !== null && message.from === "client") {
							messages[id] = message
						}
					}
					return {
						plan: data.plan,
						planExpiresAt: data.planExpiresAt,
						trialActivatedAt: data.trialActivatedAt,
						showRenewMessage: data.showRenewMessage,
						messages,
					}
				})
			})
	}

	render() {
		const {
			uid,
			email,
			plan,
			planExpiresAt,
			trialActivatedAt,
			price = YEAR_MONTHLY_PRICE,
			messages,
		} = this.state
		return (
			<div className="shell">
				<Navbar
					uid={uid}
					email={email}
					plan={plan}
					planExpiresAt={planExpiresAt}
					onSignIn={this.signInHandler(uid)}
					onSignOut={this.handleSignOut}
				/>
				<Messages
					uid={uid}
					messages={messages}
					onDismiss={this.handleDismiss}
				/>
				<main>
					<Switch>
						<Route exact path="/" render={() => this.renderFrontPage()} />
						<Route path="/sign-in" component={SignIn} />
						<Route path="/blog/:id" component={Blog} />
						<Route path="/blog" component={Blog} />
						<Route
							path="/pricing"
							render={() => (
								<Pro
									price={price}
									plan={plan}
									trialActivatedAt={trialActivatedAt}
									uid={uid}
								/>
							)}
						/>
						<Route path="/settings" render={() => <Settings uid={uid} />} />
					</Switch>
				</main>
			</div>
		)
	}

	renderFrontPage() {
		const {
			uid,
			email,
			plan,
			planExpiresAt,
			trialActivatedAt,
			showRenewMessage,
			messages,
			price = YEAR_MONTHLY_PRICE,
		} = this.state
		if (uid) {
			const upgradeMessage = messages.upgrade
			return (
				<div>
					<App
						uid={uid}
						price={price}
						plan={plan}
						planExpiresAt={planExpiresAt}
						trialActivatedAt={trialActivatedAt}
						showRenewMessage={showRenewMessage}
						onMessage={this.handleMessage}
						upgradeMessage={upgradeMessage}
					/>
					{email !== null ? <Wootric uid={uid} email={email} /> : null}
				</div>
			)
		} else {
			return <FrontPage />
		}
	}

	signInHandler(uid: ?String) {
		return async () => {
			try {
				await signIn(uid)
			} catch (error) {
				this.setMessage(
					"client.signIn",
					`Couldn't sign in: ${error.message}`,
					"danger"
				)
				throw error
			}
		}
	}

	handleSignOut = async () => {
		try {
			await signOut()
		} catch (error) {
			this.setMessage(
				"client.signIn",
				`Couldn't sign out: ${error.message}`,
				"danger"
			)
			throw error
		}
	}

	handleMessage = (id: string, message: string, level: string = "info") => {
		this.setMessage(id, message, level)
	}

	setMessage(id: string, message: string, level: string = "info") {
		this.setState((prevState, props) => ({
			messages: Object.assign({}, prevState.messages, {
				[id]: {
					from: "client",
					message,
					level,
				},
			}),
		}))
	}

	handleDismiss = (id: string) => {
		this.setState((prevState, props) => ({
			messages: Object.assign({}, prevState.messages, {
				[id]: null,
			}),
		}))
	}
}



// WEBPACK FOOTER //
// ./src/Shell.js